/**
 * @returns {string | null} Error message, or null if valid.
 */
export function validatePhoneNumber(value) {
  const trimmed = (value ?? "").trim();
  if (!trimmed) {
    return "Phone number is required.";
  }
  if (!/^[\d\s\-+().]+$/.test(trimmed)) {
    return "Use only digits and common separators (+, spaces, -, parentheses).";
  }
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length < 8) {
    return "Enter at least 8 digits.";
  }
  if (digits.length > 15) {
    return "Phone number cannot exceed 15 digits.";
  }
  return null;
}
